import { CustomerTable } from "../../../../../../Common/CustomTable";

const CustomerDetails = ({data}) => {
    const {guest:guests}=data;
  
    const guestInfo = [guests]?.map((guest, index) => ({
        Name: `${guest.first_name} ${guest.last_name}`,
        Email: guest.email,
        Phone: guest.phone,
        Room: data?.reservation?.rooms?.map(item=>item.room_number).join(', ') || "N/A",
        // Room: data?.reservation?.rooms?.map(item=>item.room_number).join(', ') || "N/A",
        Status: data?.reservation?.booking_status,
      }));

    return (
        <div className="col-md-12">
            <div className="card">
                <div className="card-header">
                    <h6 className="card-title">Customer Details</h6>
                </div>
                <div className="card-body">
                    <CustomerTable guestInfo={guestInfo} />
                </div>
            </div>
        </div>
    );
};

export default CustomerDetails;
